"use strict";

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZixunDetail = getZixunDetail;
exports.getRecommend = getRecommend;
exports.getWxSignature = getWxSignature;
exports.getVideoDetail = getVideoDetail;
exports.getRecommendVideoInfo = getRecommendVideoInfo;
exports.getSTSAccess = getSTSAccess;
exports.queryStockList = queryStockList;
exports.recordUserVisitedCount = recordUserVisitedCount;

var _request = _interopRequireDefault(require("@/utils/request"));

// 参数 get请求用params  post请求用data
function getZixunDetail(data, source, type, market) {
  // 获取资讯详情接口
  var url = '';
  var params = {};
  var method = 'get';

  switch (source) {
    case 'ZTCJ':
      // 智通财经
      url = '/kgl-adv-center/common/info/detail?recId=' + data; // params = {
      //   'recId': data
      // }

      method = 'get';
      break;

    case 'YQJJ':
      // 舆情聚焦
      url = '/kgl-adv-center/adv/news/detail';
      method = 'post';
      params = {
        'id': data
      };
      break;

    case 'globalNews':
      // 全球要闻
      url = '/kgl-adv-center/globalNews/queryDetailByArticleCode?articleCode=' + data;
      method = 'get';
      break;

    case '7x24':
      // 7*24小时
      url = '/kgl-adv-center/adv/news/selectTdx724InfoById?contentId=' + data;
      method = 'get';
      break;

    case 'rrSyncMain':
      // 研报中心
      url = '/kgl-adv-center/rrSyncMain/queryRrSyncMainByReportId?reportId=' + data;
      method = 'get';
      break;

    default:
      // 默认 通达信
      url = '/kgl-adv-center/tdx/adv/detail';
      params = {
        type: type,
        market: market,
        source: source,
        'reqParams': [type === '2' ? market === 'A' ? '101' : '802' : '1', data] // 如果是2（公告），则改变参数，沪深A股使用101,其它均为802；默认为1

      };
      method = 'post';
      break;
  }

  return (0, _request.default)({
    url: url,
    method: method,
    data: params
  });
}

function getRecommend(data) {
  // 获取相关推荐接口
  return (0, _request.default)({
    url: '',
    method: 'post',
    data: data
  });
}

function getWxSignature(params) {
  // 获取微信权限接口
  return (0, _request.default)({
    url: '/kgl-user-center/wxApi/getSignature',
    method: 'get',
    params: params
  });
}

function getVideoDetail(mediaId) {
  // 获取视频资讯的详情
  return (0, _request.default)({
    url: '/kgl-adv-center/mediaSourceInfo/selectMediaDetailInfo',
    method: 'post',
    data: {
      mediaId: mediaId
    }
  });
}

function getRecommendVideoInfo(mediaId) {
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  // 获取底部更多视频资讯的信息
  return (0, _request.default)({
    url: '/kgl-adv-center/mediaSourceInfo/selectMediaInfoByPage',
    method: 'post',
    data: {
      mediaId: mediaId,
      pageSize: pageSize
    }
  });
}

function getSTSAccess(params) {
  // 获取STS播放授权
  return (0, _request.default)({
    url: '/kgl-adv-center/vodAuth/getStsToken',
    method: 'get',
    params: params
  });
}

function queryStockList(stockCodeWithMarket) {
  return (0, _request.default)({
    url: '/kgl-adv-center/globalNews/getStockInfoListByStock',
    method: 'get',
    params: {
      stockCodeWithMarket: stockCodeWithMarket
    }
  });
}

function recordUserVisitedCount(token, rewardCode) {
  _request.default.defaults.headers.common.Authorization = token;
  return (0, _request.default)({
    url: '/kgl-user-center/userRewardApp/saveOrUpdateRewardTask',
    method: 'post',
    data: {
      rewardCode: rewardCode
    }
  });
}